import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private http : HttpClient) { }

  public CheckAccount(NationalCode) : Observable<any>
  {
    return this.http.post(environment.Api_Base_Url + "patient-client/check/",
    {
      access_token : environment.Master_Key,
      NationalCode
    })
  }

  public CreateAccount(NationalCode, Phone) : Observable<any>
  {
    return this.http.post(environment.Api_Base_Url + "patient-client/create/",
    {
      access_token : environment.Master_Key,
      NationalCode,
      Phone
    })
  }

  public Login(NationalCode, VerificationCode) : Observable<any>
  {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Basic ' + btoa(`${NationalCode}:${VerificationCode}`)
      })
    };

    return this.http.post(environment.Api_Base_Url + "patient-client/login/", 
    { access_token : environment.Master_Key }, httpOptions);
  }

  public GetGraphies() : Observable<any>
  {
    return this.http.get(environment.Api_Base_Url + "patient-client/graphies/",
    {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': `Bearer ${localStorage.getItem("access_key")}`
      })
    })
  }

  public GetPrescriptions() : Observable<any>
  {
    return this.http.get(environment.Api_Base_Url + "patient-client/prescriptions/",
    {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': `Bearer ${localStorage.getItem("access_key")}`
      })
    })
  }

  public ChangePhoneNumber(NationalCode, Phone) : Observable<any>
  {
    return this.http.post(environment.Api_Base_Url + "patient-client/change-number/",
    {
      access_token : environment.Master_Key,
      NationalCode,
      Phone
    })
  }

  public GetGraphy(Id) : Observable<any>
  {
    return this.http.post(environment.Api_Base_Url + "patient-client/graphy/",
    {
      Id
    })
  }

}
